"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePropType = exports.sharedPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var sharedPropTypes = {
  label: _propTypes["default"].node,
  onChange: _propTypes["default"].func,
  withTodayString: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string
};
exports.sharedPropTypes = sharedPropTypes;

var datePropType = function datePropType(moment) {
  return _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date), _propTypes["default"].instanceOf(moment)]);
};

exports.datePropType = datePropType;